/**
 * Add components by event and in your desired order
 * @type {[*]}
 */
let components = [
    ['ready', [
        require('./../components/cookie-notice'),
        require('./../lib/equalHeights'),
        require('./../components/general'),
        require('./../components/form'),
        require('./../components/scroller'),
        require('./../components/trigger'),
        require('./../components/slider'),
        require('./../components/popup'),
        require('./../components/menu'),
        require('./../components/sideMenu'),
        require('./../components/lazy-load'),
        require('./../components/floating-header'),
        require('./../components/notice-banner'),
        require('./../components/contact-map'),
        require('./../components/video-player'),
        require('./../components/autocomplete'),
        require('./../components/trap-focus'),
    ]],
];

module.exports = components;
